// common/getDictByType
import httpServer from '@/api/http';
export const getDictByType = (data) => {
    return httpServer(
      {
        url: "common/getDictByType",
      },
      data
    );
  };

  export const getOrganizationList=(data)=>{
    return httpServer(
      {
        url: "organization/getOrganizationList",
      },
      data
    );
  }
//获取省市区
export const getAreasByParentCode = (data) => {
 return httpServer(
   {
    url: "common/getAreasByParentCode",
   },
   data
 );
};
